/**
 * Add app icons to the template cache so they may be referenced from apps.json
 */
export const APP_ICONS_CACHE_PREFIX = 'app-switcher/icons/';
export default function cacheAppIcons($templateCache) {
  'ngInject';

  // (Use the html loader to pull the SVG content directly into the template cache.)
  const requireIcon = require.context('!html!./icons', true, /\.svg$/);

  _.forEach(requireIcon.keys(), icon => {
    // Store icons in cache at app-switcher/icons/Box.svg
    // strip off leading ./
    let iconFileName = icon.substr(2);
    $templateCache.put(APP_ICONS_CACHE_PREFIX + iconFileName, requireIcon(icon));
  });
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/mini-apps/app-switcher/cache-icons.run.js